import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import {
  NotificationsActive,
  Repeat,
  Person,
  Palette,
  Settings as SettingsIcon,
  Category
} from '@mui/icons-material';
import NotificationPreferences from '../components/settings/NotificationPreferences';
import RecurringTasksList from '../components/tasks/RecurringTasksList';
import ProfileSettings from '../components/settings/ProfileSettings';
import ThemeSelector from '../components/settings/ThemeSelector';
import CategoryManagement from '../components/settings/CategoryManagement';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const SettingsPage: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
        <SettingsIcon color="primary" />
        Settings
      </Typography>

      <Paper sx={{ mb: 3 }}>
        <Tabs 
          value={tabValue} 
          onChange={(_, v) => setTabValue(v)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab 
            icon={<Person />} 
            label="Profile" 
            iconPosition="start"
          />
          <Tab 
            icon={<Palette />} 
            label="Theme" 
            iconPosition="start"
          />
          <Tab 
            icon={<Category />} 
            label="Categories" 
            iconPosition="start"
          />
          <Tab 
            icon={<Repeat />} 
            label="Recurring Tasks" 
            iconPosition="start"
          />
          <Tab 
            icon={<NotificationsActive />} 
            label="Notifications" 
            iconPosition="start"
          />
        </Tabs>
      </Paper>

      <TabPanel value={tabValue} index={0}>
        <ProfileSettings />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <ThemeSelector />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <CategoryManagement />
      </TabPanel>

      <TabPanel value={tabValue} index={3}>
        <RecurringTasksList />
      </TabPanel>

      <TabPanel value={tabValue} index={4}>
        <NotificationPreferences />
      </TabPanel>
    </Container>
  );
};

export default SettingsPage;
